module.exports = __webpack_public_path__ + "img/image16.331cfd7b.png";